module.exports = __webpack_public_path__ + "img/017-1.a3ff32f7.png";